export default __webpack_public_path__ + "5acf8992918a43ed10935c90f95358a8.svg";